<ion-header class="kioskPageStyle kiosk-screen">
  <div class="header">
    <div class="kiosk-buttons">
      <div class="btn-div" tappable data-cy="kioskMode-hdr-dismissBtn">
        <!-- <ion-buttons slot="start">
          <ion-menu-button color="primary" [ngClass]="currentScreen == 0 ? 'solid-bg-menu-button' : ''"
            (click)="presentPopover($event)" autoHide="false"></ion-menu-button>
        </ion-buttons> -->
        <div class="menu-button ripple link" (click)="toggleMenu()">
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
        </div>
      </div>

      <div class="progressIndicator"
        *ngIf="!isMenuOpen && !!currentScreen && !!numberOfScreens && (numberOfScreens + 1 > currentScreen)">
        <app-custom-progress class="app-custom-progress" [totalSteps]="numberOfScreens + 1"
          [currentStep]="currentScreen"></app-custom-progress>
      </div>

      <div [ngClass]="reference.MenuEnabled">
        <ion-button [disabled]="dataIsLoading" color="light" class="btnPrev link" *ngIf="showPrev" tappable
          (click)="prev()" data-cy="kioskMode-hdr-previousBtn">
          <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
        </ion-button>
        <ion-button class="btnNext link" *ngIf="showNext" tappable [disabled]="!isNextValid"
          (click)="treatNextAsHandleNo ? overrideNextWithNo() : next($event)" data-cy="kioskMode-hdr-nextBtn">
          <ion-icon slot="icon-only" name="arrow-forward-outline"></ion-icon>
        </ion-button>
      </div>
    </div>
  </div>

  <!-- OFFLINE INDICATOR -->
  <div *ngIf="initialized && !plt.is('cordova') && networkProvider.isKioskOffline()" class="offlineDiv link">
    <span class="link" (click)="noInternetConnectionWarning()">Check Internet Connectivity to Prevent Data Loss
      <ion-icon name="cloud-offline-outline"></ion-icon></span>
  </div>
</ion-header>

<ion-content forceOverscroll="false" id="main" class="kioskPageStyle kiosk-screen">



  <!-- <iframe *ngIf="pdfSrc" [src]="pdfSrc" width="100%" height="600px"></iframe> -->

  <div class="swiper1">
    <div class="swiper-wrapper">
      <div class="swiper-slide menu">
        <div class="menu-list">
          <ion-list lines="none">
            <ion-item lines="none" class="link ion-activatable menuHoverButton" (click)="close()" *ngIf="options?.close"
              data-cy="listingAction-exit">
              <ion-label class="link"><ion-icon name="exit-outline"></ion-icon> Exit</ion-label>

            </ion-item>
            <ion-item lines="none" class="link ion-activatable" (click)="restartKiosk()" *ngIf="options?.restart"
              data-cy="listingAction-restart">

              <ion-label class="link"><ion-icon name="refresh-outline"></ion-icon> Restart</ion-label>
            </ion-item>
            <ion-item lines="none" class="link ion-activatable" (click)="skipQuestion()" *ngIf="options?.skip"
              data-cy="listingAction-skipQuestion">

              <ion-label class="link"><ion-icon name="play-skip-forward-outline"></ion-icon> Skip Question</ion-label>
            </ion-item>
            <ion-item lines="none" class="link ion-activatable" (click)="addNote()" *ngIf="options?.addNotePrev"
              data-cy="listingAction-noteForPreviousGuest">

              <ion-label class="link"><ion-icon name="document-text-outline"></ion-icon> Add note for previous
                guest</ion-label>
            </ion-item>
          </ion-list>
        </div>

        <!-- <div *ngIf="qrCodeAgentSignin" class="qrcode">
          <p> Real Estate Agent Sign-in <ion-icon name="information-circle" (click)="showRealEstateAgentInfo()" ></ion-icon>
          </p>
          <img [src]="qrCodeAgentSignin | safe: 'url'" alt="QR Code Signin" title="QR Code Signin">
        </div> -->

      </div>


      <div class="swiper-slide content" (click)="clickOnMainView()">
        <swiper-container id="swiperRef" #swiperRef class="swiper mySwiper invisible" [ngClass]="loadProgressBar"
          *ngIf="loaded" init="false" (click)="tap()">

          <!-- Slide: Property Preview -->
          <swiper-slide class="swiper-slide" swiperSlide data-swiper-animation="animate__fadeIn" data-duration=".5s"
            data-delay="1s" data-swiper-out-animation="animate__fadeOut" data-out-duration=".2s">
            <app-property-layout [mode]="currentListing.propertyLayout" *ngIf="currentListing"
              [listing]="currentListing" data-cy="kioskMode-firstSlide-listingItem">
            </app-property-layout>

            <div class="privacyFooterIntro" data-cy="kioskMode-firstSlide-legalLinks" [ngClass]="orientation">
              {{mortgageQuestionDetails.GuestDisclaimer}} <span class="link underline" (click)="terms($event);">Terms of
                Use</span><span> and </span><span class="link underline" (click)="privacy($event);">Privacy
                Policy</span>
            </div>
            <div class="listingQR" [ngClass]="reference.MenuEnabled" *ngIf="!isMobilePhone 
              && userData.touchFreeSignIn === true 
              && currentListing.slug 
              && currentListing.slug !== '' 
              && currentListing.webPublished === true 
              && (currentListing.enhancedMode === true || lenderOverride)">

              <ion-img class="qrCodeImageDiv" *ngIf="qrCodeImageData" src="{{qrCodeImageData}}" alt="Dynamic QR Code"
                title="Listing QR Code" data-cy="kioskMode-firstSlide-qrCode2"></ion-img>
            </div>

          </swiper-slide>

          <!-- Slide: Full Name -->
          <swiper-slide class="swiper-slide" swiperSlide data-swiper-animation="animate__fadeIn" data-duration=".5s"
            data-delay="1s" data-swiper-out-animation="animate__fadeOut" data-out-duration=".2s">
            <div class="slide-page">
              <div class="slide-page--title" data-cy="kioskMode-secondSlide-name-lbl">Full Name</div>
              <form>
                <ion-input mode="ios" id="nameKiosk" #nameKiosk enterkeyhint="go" autocapitalize="words"
                  autocomplete="off" spellcheck="false" type="text" inputmode="text"
                  [value]="guestSurveyData.guest.fullName" (keydown.enter)="checkKey($event)"
                  (keydown.Tab)="checkKey($event)" [disabled]="!enableInput" (input)="onNameChange($event.target.value)"
                  data-cy="kioskMode-secondSlide-name-input">
                </ion-input>
              </form>
            </div>
          </swiper-slide>

          <!-- Slide: Mobile Number -->
          <swiper-slide class="swiper-slide" swiperSlide data-swiper-animation="animate__fadeIn" data-duration=".5s"
            data-delay="1s" data-swiper-out-animation="animate__fadeOut" data-out-duration=".2s">
            <div class="slide-page">
              <div class="slide-page--title" data-cy="kioskMode-thirdSlide-phone-lbl">Mobile Number</div>
              <form class="input-phone" data-cy="kioskMode-thirdSlide-phone-input">
                <input type="tel" id="phoneKiosk" #phoneKiosk class="internationalPhone" enterkeyhint="go"
                  [disabled]="!enableInput" autocomplete="off" spellcheck="false" myNumberOnly
                  [ngClass]="{'valid-input': isNextValid, 'not-valid-input': !isNextValid}" inputmode="tel"
                  (ionBlur)="resetField('phone')" [value]="guestSurveyData.guest.phoneNumber"
                  (input)="onPhoneChange($event.target.value)" (keydown.enter)="checkKey($event)"
                  (keydown.Tab)="checkKey($event)" max-length="10">
              </form>
              <!-- <ion-item lines="none" mode="ios" *ngIf="enableKioskOptIn" class="optInCheckBox"
                data-cy="kioskMode-mobileSlide-kioskOptIn">
                <ion-checkbox lines="none" [(ngModel)]="checkedOptIn" mode="ios"
                  (ngModelChange)="kioskChanged(checkedOptIn)"></ion-checkbox>
                <ion-label class="ion-text-wrap">{{SmsOptInDisclaimer}}</ion-label>
              </ion-item> -->
              <div class="privacyFooterMobile" data-cy="kioskMode-mobileSlide-smsMessage">
                <p data-cy="kioskMode-mobileSlide-mcqdisclaimer">
                  {{ agentMarketingCommunicationsDisclosure }}
                  <span> For more info review our </span>
                  <span class="link underline" (click)="privacy($event);">Terms and Privacy Policy here</span>
                </p>
              </div>

            </div>
          </swiper-slide>

          <!-- Slide: Email -->
          <swiper-slide class="swiper-slide" swiperSlide data-swiper-animation="animate__fadeIn" data-duration=".5s"
            data-delay="1s" data-swiper-out-animation="animate__fadeOut" data-out-duration=".2s">
            <div class="slide-page">
              <div class="slide-page--email" data-cy="kioskMode-fourthSlide-email-lbl">Email</div>
              <form>
                <ion-input mode="ios" id="emailKiosk" #emailKiosk enterkeyhint="go" [disabled]="!enableInput"
                  autocomplete="off" spellcheck="false" [value]="guestSurveyData.guest.email"
                  [ngClass]="{'valid-input': isNextValid, 'not-valid-input': !isNextValid}" type="email"
                  (keydown.enter)="checkKey($event)" (keydown.Tab)="checkKey($event)" inputmode="email"
                  (input)="onEmailChange($event.target.value)" data-cy="kioskMode-fourthSlide-email-input">
                </ion-input>
                <ion-radio-group (onChange)="changeDomainCallback($event)" [value]="selectedDomain">
                  <swiper-container #emailList id="emailList" [ngClass]="enableEmailList" init="false">
                    <ng-container *ngFor="let domain of emailDomains; let domainIndex = index">
                      <swiper-slide class="animated animatedFadeInUp fadeInUp">
                        <div class="radio-group ripple"
                          [ngClass]="{'selected': selectedDomain === domain.id, 'un-selected' : selectedDomain !== domain.id}"
                          (click)="addEmailDomain(domain)">
                          <ion-radio labelPlacement="end" [value]="domain.id">

                          </ion-radio>
                          <p>{{domain.title}}</p>

                        </div>
                      </swiper-slide>
                    </ng-container>
                  </swiper-container>
                </ion-radio-group>
              </form>
            </div>
          </swiper-slide>

          <!-- Slide: Mortgage Questions -->
          <swiper-slide class="swiper-slide" swiperSlide data-swiper-animation="animate__fadeIn" data-duration=".5s"
            data-delay="1s" data-swiper-out-animation="animate__fadeOut" data-out-duration=".2s"
            *ngFor="let slide of guestSurveyData.questionsAnswers; let i = index; trackBy: trackByFn">

            <!-- OLD MORTGAGE QUESTION -->
            <div class="slide-question" *ngIf="!customMortgageQuestion || customMortgageQuestion.style ==='old'">
              <div *ngIf="slide.question === 'Are you looking For Info Regarding a Mortgage?'"
                class="fullHeight fullWidth">
                <div class="slide-question__mortgage" data-cy="kioskMode-fifthSlide-title">
                  {{mortgageQuestionDetails.MortgageQuestion}}
                </div>

                <div class="slide-question__answers">
                  <div (click)="handleYes(i)" button class="slide-question__circle slide-question__circle--primary link"
                    data-cy="kioskMode-fifthSlide-yesAnswer">
                    {{mortgageQuestionDetails.yesAnswer}}
                  </div>
                  <div (click)="handleNo(i)" button class="slide-question__circle slide-question__circle--primary link"
                    data-cy="kioskMode-fifthSlide-noAnswer">
                    {{mortgageQuestionDetails.noAnswer}}
                  </div>
                </div>


                <div *ngIf="onlineStatus === true" class="kioskMortgageSubtitle"
                  data-cy="kioskMode-fifthSlide-expert-title">A
                  mortgage expert is available</div>
                <div class="pad-top-20"></div>

                <div *ngIf="onlineStatus === true" class="kioskLoanWrapper"
                  [ngClass]="!anyReviewEnabled ? 'review-disabled-view' : ''">

                  <ion-row class="lender-border">
                    <ion-col size="12" *ngIf="!anyReviewEnabled">
                      <h4 class="bold margin-left-10 margin-top-2" data-cy="kioskMode-fifthSlide-kiosk-name">
                        {{loanOfficer.name}}</h4>
                    </ion-col>
                    <div class="pad-top-10"></div>
                    <ion-col size="12" *ngIf="!anyReviewEnabled">
                      <h4 class="margin-left-10 margin-top-2" data-cy="kioskMode-fifthSlide-kiosk-company">
                        {{loanOfficer.company}}</h4>
                    </ion-col>
                    <!-- <ion-col size="12" *ngIf="!anyReviewEnabled"> -->
                    <div class="user-image-wrapper" *ngIf="!anyReviewEnabled">
                      <app-profile-image-item *ngIf="profileImgShow" [kioskCheck]="true" class="loanOfficerImg"
                        [profile]="loanOfficer">
                      </app-profile-image-item>

                      <div class="userLogoImage" *ngIf="lenderUserLogo && loanOfficer.image">
                        <img src="{{lenderUserLogo}}">
                      </div>
                    </div>
                    <!-- </ion-col> -->
                    <div class="user-image-wrapper" *ngIf="anyReviewEnabled">
                      <app-profile-image-item *ngIf="profileImgShow" [kioskCheck]="true" class="loanOfficerImg"
                        [profile]="loanOfficer" data-cy="kioskMode-fifthSlide-kiosk-profImg">
                      </app-profile-image-item>

                      <div class="userLogoImage" *ngIf="lenderUserLogo && loanOfficer.image">
                        <img src="{{lenderUserLogo}}" data-cy="kioskMode-fifthSlide-kiosk-logo">
                      </div>
                    </div>

                    <div class="leftAlign margin-left-10" *ngIf="anyReviewEnabled">

                      <div class="bold margin-left-10 margin-top-2">{{loanOfficer.name}}</div>
                      <div class="margin-left-10 margin-top-2">{{loanOfficer.company}}</div>
                      <ion-row>

                        <div *ngFor="let item of loanOfficerReviews">
                          <ion-col size="6" class="no-padding">
                            <!-- <div class="pad-top-5" > -->
                            <div>
                              <div class="kioskLoanOfficerReview" *ngIf="item.review.enabled">
                                <img class="reviewLogo" src="{{item.review.reviewLogo}}">

                                <span class="reviewScore"
                                  data-cy="kioskMode-fifthSlide-kiosk-review-score">{{item.review.reviewStars |
                                  number:'1.1'
                                  }}</span>

                                <div class="reviewRatingSection">
                                  <ionic-rating-component activeIcon="star" maxRating="1" defaultIcon="star-outline"
                                    activeColor="#FFBB54" defaultColor="#C1C8D7" rating="{{item.review.reviewStars}}"
                                    readonly="true" fontSize="18px" data-cy="kioskMode-fifthSlide-kiosk-review-rating">
                                  </ionic-rating-component>
                                </div>
                                <div class="font-12 reviewCount" data-cy="kioskMode-fifthSlide-kiosk-review-count">
                                  ({{item.review.reviewCount}})</div>
                              </div>

                            </div>
                          </ion-col>
                        </div>

                      </ion-row>
                    </div>

                  </ion-row>

                </div>

                <div class="privacyFooter" data-cy="kioskMode-fifthSlide-footer-txt">
                  {{ lenderMarketingCommunicationsDisclosure }}
                  <span> For more info review our </span>
                  <span (click)="openLenderPrivacyURL($event);" class="link underline">Terms and Privacy Policy
                    here</span>
                </div>
              </div>
              <div *ngIf="slide.question !== 'Are you looking For Info Regarding a Mortgage?'">
                <div class="slide-question__title question_wrapper">
                  <div class="question_subwrap">
                    {{slide.question}}
                  </div>
                </div>

                <div *ngIf="slide.type === 'yesNo'" class="slide-question__answers">
                  <div (click)="handleYes(i)" tappable
                    class="slide-question__circle slide-question__circle--primary link click">
                    Yes
                  </div>
                  <div (click)="handleNo(i)" tappable
                    class="slide-question__circle slide-question__circle--primary link click">
                    No
                  </div>
                </div>

                <div *ngIf="slide.type === 'text'" class="slide-question__input-answers">
                  <form>
                    <ion-input mode="ios" [disabled]="!enableInput" enterkeyhint="go" autocapitalize="sentences"
                      autocorrect="true" autocomplete="on" spellcheck="true" type="text" [id]="slide.divId"
                      (keydown.enter)="checkKey($event)" (keydown.Tab)="checkKey($event)" [(ngModel)]="slide.answer"
                      [ngModelOptions]="{standalone: true}" (input)="handleQuestionInputAnswers($event.target.value)">
                    </ion-input>
                  </form>
                </div>

                <div *ngIf="slide.type === 'number'" class="slide-question__input-answers">
                  <form>
                    <ion-input mode="ios" [disabled]="!enableInput" autocomplete="off" type="number" myNumberOnly
                      [pattern]="NUMBER_REGEX" min="0" [id]="slide.divId" (keydown.enter)="checkKey($event)"
                      (keydown.Tab)="checkKey($event)" [(ngModel)]="slide.answer" [ngModelOptions]="{standalone: true}"
                      (input)="handleQuestionInputAnswers($event.target.value)">
                    </ion-input>
                  </form>
                </div>

                <div *ngIf="showMultipleChoice && slide?.multipleChoiceOptions && slide.type === 'multipleChoice'"
                  class="slide-question__multiple-choice-answers">

                  <ion-radio-group [allowEmptySelection]="true" [(ngModel)]="selectedCheckbox[currentScreen.toString()]"
                    (ionChange)="multipleChoiceOptionChanged(slide, $event)" (keydown.enter)="checkKey($event)"
                    (keydown.Tab)="checkKey($event)" data-cy="kioskMode-multipleChoiceQuestions-group">

                    <!-- FIRST ITEM ONLY SHOWN IF CHOICE WITH DETAILS -->
                    <div class="highlightedWrapper">
                      <ion-item id="highlightedChoice" *ngIf="showMultipleInput" (keydown.enter)="checkKey($event)"
                        no-padding class="radio-class animated-element" tappable mode="ios" lines="none">

                        <div class="inline-grid highlightedChoiceBox verticalAlign" justify="start">
                          <ion-radio labelPlacement="end" color="primary" mode="ios"
                            [value]="highlightedChoice[currentScreen.toString()]?.value"
                            class="verticalAlign inline-grid"><ion-label class="verticalAlign inline-grid">{{
                              highlightedChoice[currentScreen.toString()]?.value }}</ion-label>
                          </ion-radio>

                        </div>

                        <ion-input autocapitalize="sentences" autocorrect="true" autocomplete="on" spellcheck="true"
                          class="choiceDetailsInput" [id]="'input'+slide.type+slide.question"
                          placeholder="{{highlightedChoice[currentScreen.toString()].details?.textPrompt}}"
                          [(ngModel)]="highlightedChoice[currentScreen.toString()].details.inputValue"
                          (input)="multiChoiceInputChanged(slide,$event)" (keydown.enter)="checkKey($event)"
                          (keydown.Tab)="multiChoiceInputChanged(slide,$event)"></ion-input>
                      </ion-item>
                    </div>
                    <!-- END OF FIRST ITEM -->

                    <div *ngFor="let option of slide.multipleChoiceOptions; let j = index">
                      <ion-item *ngIf="highlightedChoice[currentScreen.toString()] !== option" no-padding
                        class="radio-class" tappable mode="ios" lines="none"
                        [attr.data-cy]="'kioskMode-multipleChoiceQuestions-group-question-' + j">
                        <ion-radio labelPlacement="end" color="primary" mode="ios" justify="start"
                          [value]="option.value" (keydown.enter)="checkKey($event)"
                          (keydown.Tab)="checkKey($event)"><ion-label>{{ option.value
                            }}</ion-label></ion-radio>

                      </ion-item>
                    </div>


                  </ion-radio-group>

                  <div class="spacer-50"></div>

                </div>

              </div>
            </div>
            <!-- END -->

            <!-- NEW MORTGAGE QUESTION -->
            <div class="slide-question" *ngIf="customMortgageQuestion && customMortgageQuestion.style === 'new'">
              <div *ngIf="slide.question === 'Are you looking For Info Regarding a Mortgage?'">
                <div class="slide-question__mortgage_new">
                  {{customMortgageQuestion.question}}
                </div>

                <div>
                  <ion-button (click)="handleYes(i)" data-cy="kioskMode-fifthSlide-yesAnswer" tappable
                    class="newYesButton link">
                    {{customMortgageQuestion.yesAnswer}}
                  </ion-button>
                  <div (click)="handleNo(i)" data-cy="kioskMode-fifthSlide-noAnswer" button class="newNoButton link">
                    {{customMortgageQuestion.noAnswer}}
                  </div>
                </div>


                <div *ngIf="onlineStatus === true" class="kioskMortgageSubtitle">A mortgage expert is available</div>
                <div class="pad-top-20"></div>
                <div *ngIf="onlineStatus === true" class="kioskLoanWrapper"
                  [ngClass]="!anyReviewEnabled ? 'review-disabled-view' : ''">
                  <ion-row class="lender-border">
                    <ion-col size="12" *ngIf="!anyReviewEnabled">
                      <h4 class="bold margin-left-10 margin-top-2">{{loanOfficer.name}}</h4>
                    </ion-col>
                    <div class="pad-top-20"></div>
                    <ion-col size="12" *ngIf="!anyReviewEnabled">
                      <h4 class="margin-left-10 margin-top-2">{{loanOfficer.company}}</h4>
                    </ion-col>
                    <!-- <ion-col size="12" *ngIf="!anyReviewEnabled"> -->
                    <div class="user-image-wrapper" *ngIf="!anyReviewEnabled">
                      <app-profile-image-item *ngIf="profileImgShow" [kioskCheck]="true" class="loanOfficerImg"
                        [profile]="loanOfficer">
                      </app-profile-image-item>

                      <div class="userLogoImage" *ngIf="lenderUserLogo && loanOfficer.image">
                        <img src="{{lenderUserLogo}}">
                      </div>
                    </div>
                    <!-- </ion-col> -->
                    <div class="user-image-wrapper" *ngIf="anyReviewEnabled">
                      <app-profile-image-item *ngIf="profileImgShow" [kioskCheck]="true" class="loanOfficerImg"
                        [profile]="loanOfficer">
                      </app-profile-image-item>

                      <div class="userLogoImage" *ngIf="lenderUserLogo && loanOfficer.image">
                        <img src="{{lenderUserLogo}}">
                      </div>
                    </div>

                    <div class="leftAlign margin-left-10" *ngIf="anyReviewEnabled">

                      <div class="bold margin-left-10 margin-top-2">{{loanOfficer.name}}</div>
                      <div class="margin-left-10 margin-top-2">{{loanOfficer.company}}</div>
                      <ion-row>
                        <div *ngFor="let item of loanOfficerReviews">

                          <ion-col size="6" class="no-padding">
                            <!-- <div class="pad-top-5" > -->
                            <div>
                              <div class="kioskLoanOfficerReview" *ngIf="item.review.enabled">
                                <img class="reviewLogo" src="{{item.review.reviewLogo}}">

                                <span class="reviewScore">{{item.review.reviewStars | number:'1.1' }}</span>

                                <div class="reviewRatingSection">
                                  <ionic-rating-component activeIcon="star" maxRating="1" defaultIcon="star-outline"
                                    activeColor="#FFBB54" defaultColor="#C1C8D7" rating="{{item.review.reviewStars}}"
                                    readonly="true" fontSize="18px">
                                  </ionic-rating-component>
                                </div>
                                <div class="font-12 reviewCount">({{item.review.reviewCount}})</div>
                              </div>
                            </div>
                          </ion-col>
                        </div>
                      </ion-row>

                    </div>

                  </ion-row>

                </div>

                <div class="privacyFooter">
                  {{ lenderMarketingCommunicationsDisclosure }}
                  <span> For more info review our </span>
                  <span (click)="openLenderPrivacyURL($event);" class="link underline">Terms and Privacy Policy
                    here</span>
                </div>
              </div>
              <div *ngIf="slide.question !== 'Are you looking For Info Regarding a Mortgage?'">

                <div class="slide-question__title question_wrapper">
                  <div class="question_subwrap">
                    {{slide.question}}
                  </div>
                </div>

                <div *ngIf="slide.type === 'yesNo'" class="slide-question__answers">
                  <div (click)="handleYes(i)" button data-cy="kioskMode-fifthSlide-yesAnswer"
                    class="slide-question__circle slide-question__circle--blue link">
                    Yes
                  </div>
                  <div (click)="handleNo(i)" button data-cy="kioskMode-fifthSlide-noAnswer"
                    class="slide-question__circle slide-question__circle--blue link">
                    No
                  </div>
                </div>

                <div *ngIf="slide.type === 'text'" class="slide-question__input-answers">
                  <form>
                    <ion-input mode="ios" [disabled]="!enableInput" enterkeyhint="go" autocomplete="off"
                      spellcheck="false" type="text" [id]="slide.divId" (keydown.enter)="checkKey($event)"
                      (keydown.Tab)="checkKey($event)" [(ngModel)]="slide.answer" [ngModelOptions]="{standalone: true}"
                      (input)="handleQuestionInputAnswers($event.target.value)">
                    </ion-input>
                  </form>
                </div>

                <div *ngIf="slide.type === 'number'" class="slide-question__input-answers">
                  <form>
                    <ion-input mode="ios" [disabled]="!enableInput" enterkeyhint="go" autocomplete="off" type="number"
                      [pattern]="NUMBER_REGEX" myNumberOnly min="0" inputmode="numeric" [id]="slide.divId"
                      (keydown.enter)="checkKey($event)" (keydown.Tab)="checkKey($event)" [(ngModel)]="slide.answer"
                      [ngModelOptions]="{standalone: true}" (input)="handleQuestionInputAnswers($event.target.value)">
                    </ion-input>
                  </form>
                </div>

                <div *ngIf="showMultipleChoice && slide?.multipleChoiceOptions && slide.type === 'multipleChoice'"
                  class="slide-question__multiple-choice-answers">
                  <ion-radio-group [allowEmptySelection]="true" [(ngModel)]="selectedCheckbox[currentScreen.toString()]"
                    (ionChange)="multipleChoiceOptionChanged(slide, $event)" (keydown.enter)="checkKey($event)">

                    <!-- FIRST ITEM ONLY SHOWN IF CHOICE WITH DETAILS -->
                    <div class="highlightedWrapper">

                      <ion-item id="highlightedChoice" (keydown.enter)="checkKey($event)" *ngIf="showMultipleInput"
                        no-padding class="radio-class animated-element" tappable mode="ios" lines="none">

                        <div class="inline-grid highlightedChoiceBox verticalAlign" justify="start">
                          <ion-radio labelPlacement="end" color="primary" mode="ios"
                            [value]="highlightedChoice[currentScreen.toString()]?.value"
                            class="verticalAlign inline-grid"><ion-label class="verticalAlign inline-grid">{{
                              highlightedChoice[currentScreen.toString()]?.value }}</ion-label></ion-radio>
                        </div>

                        <ion-input autocapitalize="sentences" autocorrect="true" autocomplete="on" spellcheck="true"
                          class="choiceDetailsInput" [id]="'input'+slide.type+slide.question"
                          placeholder="{{highlightedChoice[currentScreen.toString()]?.details?.textPrompt}}"
                          [(ngModel)]="highlightedChoice[currentScreen.toString()].details.inputValue"
                          (input)="multiChoiceInputChanged(slide,$event)" (keydown.enter)="checkKey($event)"
                          (keydown.Tab)="multiChoiceInputChanged(slide,$event)"></ion-input>
                      </ion-item>
                    </div>
                    <!-- END OF FIRST ITEM -->

                    <div *ngFor="let option of slide.multipleChoiceOptions; let j = index">
                      <ion-item *ngIf="highlightedChoice[currentScreen.toString()] !== option" no-padding
                        class="radio-class" tappable mode="ios" lines="none"
                        [attr.data-cy]="'kioskMode-multipleChoiceQuestions-group-question-' + j">
                        <ion-radio labelPlacement="end" color="primary" mode="ios" justify="start"
                          [value]="option.value" (keydown.enter)="checkKey($event)"
                          (keydown.Tab)="checkKey($event)"><ion-label>{{ option.value
                            }}</ion-label></ion-radio>

                      </ion-item>
                    </div>


                    <div class="spacer-50"></div>

                  </ion-radio-group>
                </div>

              </div>
            </div>

          </swiper-slide>

          <!-- Slide: Disclosure PDF -->
          <swiper-slide *ngIf="disclosureDoc" class="swiper-slide" swiperSlide data-swiper-animation="animate__fadeIn"
            data-duration=".5s" data-delay="1s" data-swiper-out-animation="animate__fadeOut" data-out-duration=".2s"
            (keydown.enter)="checkKey($event)">
            <div class="slide-question" *ngIf="disclosureDoc">
              <div class="pdfWrapper">

                <div class="centerAlign">
                  <div class="disclosureLabel">{{disclosureDoc.message}}</div>

                  <div class="slide-question__multiple-choice-answers">
                    <ion-radio-group [allowEmptySelection]="false"
                      [(ngModel)]="selectedCheckbox[currentScreen.toString()]"
                      (ionChange)="disclosureAccept(slide, $event)">
                      <ion-item *ngIf="disclosureDoc.confirmButton" no-padding class="radio-class" tappable mode="ios"
                        lines="none">
                        <ion-radio labelPlacement="end" color="primary" mode="ios" justify="start"
                          [value]="disclosureDoc.confirmButton">
                          <ion-label>{{ disclosureDoc.confirmButton }}</ion-label></ion-radio>

                      </ion-item>

                      <ion-item *ngIf="disclosureDoc.declineButton" no-padding class="radio-class" tappable mode="ios"
                        lines="none">
                        <ion-radio labelPlacement="end" color="primary" mode="ios" justify="start"
                          [value]="disclosureDoc.declineButton"><ion-label>{{ disclosureDoc.declineButton
                            }}</ion-label></ion-radio>

                      </ion-item>

                    </ion-radio-group>
                  </div>

                </div>

                <div class="spacer-20"></div>
                <ion-spinner *ngIf="!pdfSrc" name="crescent">
                </ion-spinner>

                <div class="pdfViewerWrapper">
                  <div id="pdfViewer" style="width: 100%; height: 100%;"></div>
                </div>

                <div class="spacer-20"></div>

              </div>
            </div>
          </swiper-slide>


          <!-- Slide: Outro -->
          <swiper-slide class="swiper-slide" swiperSlide data-swiper-animation=" animate__fadeIn" data-duration=".5s"
            data-delay="1s" data-swiper-out-animation="animate__fadeOut" data-out-duration=".2s">
            <app-property-layout [mode]="currentListing.propertyLayout" *ngIf="currentListing"
              [listing]="currentListing" data-cy="kioskMode-firstSlide-listingItem" text="outro">
            </app-property-layout>
          </swiper-slide>
        </swiper-container>

        <div class="loadingScreen" *ngIf="!loaded">
          <div class="loadingSpinner">
            <ion-label>Launching Open House...</ion-label>
          </div>
          <ion-spinner name="crescent">
          </ion-spinner>
        </div>

      </div>
    </div>
  </div>
</ion-content>